<article
    class="product-item"
    #componentRef
>
    <div
        class="product-item__tag"
        *ngIf="product?.isNew?.data"
        [innerText]="product?.isNew?.value"
    ></div>

    <a
        [routerLink]="[overviewPageUrl$ | async, product.id]"
        (click)="setCurrentYPos()"
        appInViewport
        [observeOutersection]="isOnPLP"
        (intersectOutput)="intersectInitComponent($event)"
    >
        <div
            class="product-item__image image-ratio-wrapper"
            *ngIf="resizedPictures.length"
        >
            <swiper
                *ngIf="showImageSlider && isBrowser"
                [preloadImages]="false"
                [lazy]="lazyOptions"
                [index]="currentImageIndex"
                (slideChange)="onSlideChange($event)"
                [pagination]="resizedPictures.length > 1 ? { dynamicBullets: true } : false"
                [navigation]="showNavigation"
                [effect]="'fade'"
            >
                <ng-template
                    swiperSlide
                    *ngFor="let picture of resizedPictures"
                >
                    <img
                        [attr.data-src]="picture"
                        class="swiper-lazy"
                        [alt]="altText"
                    />
                </ng-template>
            </swiper>

            <img
                *ngIf="resizedPictures.length; else fallbackIcon"
                class="product-item__initial-image"
                [src]="resizedPictures[0]"
                loading="lazy"
                [alt]="altText"
            />

            <ng-template #fallbackIcon>
                <div class="product-item__image-fallback">
                    <i
                        class="product-item__image-fallback-icon"
                        [innerHTML]="carImageFallbackIcon | safe: 'html'"
                    ></i>

                    <p
                        class="product-item__image-fallback-text"
                        [innerText]="'filterpage.image_fallback_text' | translate"
                    ></p>
                </div>
            </ng-template>
        </div>

        <div class="product-item__content">
            <div class="product-item__info">
                <h3 class="product-item__info-header">
                    {{ product?.make?.value }}
                    {{ product?.model?.value }}
                    <div class="product-item__info-header--secondary">
                        {{ carModelDataToDecimal }}
                        {{ product?.variant?.value }}
                    </div>
                </h3>
                <div class="product-item__info-text">
                    <span>{{ product?.year?.value }}, </span>
                    <span>{{ product?.mileage?.data | number }} km.</span>
                    <div
                        class="product-item__info-dealer"
                        *ngIf="product?.dealerAlternativeName?.value"
                    >
                        <span
                            class="product-item__info-dealer-icon"
                            [innerHTML]="pinIcon | safe: 'html'"
                        ></span>

                        {{ product?.dealerAlternativeName?.value }}
                    </div>
                </div>

                <app-product-item-price
                    class="product-item__price"
                    *ngIf="leasingOptions$ | async as leasingOptions"
                    [agreement]="leasingOptions.leasingType"
                    [car]="product"
                    [purpose]="leasingOptions.leasingPurpose"
                    [showLeasingPrice]="
                        isMotorpoint ? !showCashPrice : showLeasingPrices || isLeasingOnlyPage
                    "
                ></app-product-item-price>
            </div>

            <div
                class="product-item__valuation"
                *ngIf="!isMotorpoint && !showLeasingPrices && !isLeasingOnlyPage"
            >
                <app-product-item-valuation-badge
                    [valuationString]="product?.indicataPriceLevel?.value"
                ></app-product-item-valuation-badge>
            </div>

            <div class="product-item__buying-options">
                <div class="product-item__buying-option">
                    <span
                        class="checkmark-icon"
                        *ngIf="product?.isBuyable?.data"
                        [innerHTML]="checkmarkIcon | safe: 'html'"
                    ></span>

                    <span
                        class="cross-icon"
                        *ngIf="!product?.isBuyable?.data"
                        [innerHTML]="crossLightIcon | safe: 'html'"
                    ></span>

                    {{
                        (isMotorpoint
                            ? 'filterpage.buy_online'
                            : 'filterpage.product_card_buy_online_text'
                        ) | translate
                    }}
                </div>

                <div class="product-item__buying-option">
                    <span
                        class="checkmark-icon"
                        [innerHTML]="checkmarkIcon | safe: 'html'"
                    ></span>

                    {{
                        (isMotorpoint
                            ? 'filterpage.buy_in_showroom'
                            : 'filterpage.product_card_buy_at_dealership_text'
                        ) | translate
                    }}
                </div>
            </div>
        </div>
    </a>
</article>
